import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_LIST_QUERY_KEY,
  BRIEF_SUGGESTED_INFLUENCERS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { BriefService } from "@entities/brief/lib/services/brief.service";
import { INFLUENCER_SUGGEST_REQUEST_FACETS } from "@entities/influencer/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { PricingTrackerService } from "../services/pricing.tracker.service";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";
import { PRICING_ANALYTICS_QUERY_KEY } from "../constants";

export default function useUpdatePricingAnalytics() {
  const {
    mutate: updatePricingAnalytics,
    isLoading: isUpdatingPricingAnalytics,
    isError: isUpdatingPricingAnalyticsError,
    isSuccess: isUpdatingPricingAnalyticsSuccess,
    error: updatingPricingAnalyticsError,
    variables: updatingPricingAnalyticsVariables,
  } = useMutation({
    mutationFn: (data: { briefInfluencerIds: string[] }) =>
      PricingTrackerService.updatePricingAnalytics(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: [...PRICING_ANALYTICS_QUERY_KEY] });
    },
  });

  return {
    updatePricingAnalytics,
    isUpdatingPricingAnalytics,
    isUpdatingPricingAnalyticsError,
    isUpdatingPricingAnalyticsSuccess,
    updatingPricingAnalyticsError,
    updatingPricingAnalyticsVariables,
  };
}
